// @flow
// $FlowFixMe - Cannot import useEffect because there is no useEffect export in react.
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Select from './Select';
import type { SelectOptions } from './types';

type SelectHookFormProps = {
  defaultValue?: ?any,
  name: string,
  options: SelectOptions,
  rules?: ?any,
  'aria-label': string,
  isLoading?: boolean,
};

const SelectHookForm = ({
  defaultValue,
  name,
  options,
  rules,
  isLoading,
  ...props
}: SelectHookFormProps) => {
  const { control, setValue } = useFormContext();

  useEffect(() => {
    const defaultValueOption = options.find(option => option.value === defaultValue);
    // set default as value after loading options is done
    if (defaultValueOption && !isLoading) {
      setValue(name, defaultValueOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, isLoading]);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <Select
          error={error}
          isLoading={isLoading}
          onBlur={onBlur}
          onChange={onChange}
          options={options}
          value={value}
          {...props}
        />
      )}
    />
  );
};

SelectHookForm.defaultProps = {
  defaultValue: undefined,
  rules: undefined,
  isLoading: false,
};

export default SelectHookForm;
